<template>
  <DpplEnhancedTooltip
    v-if="typeof specificityData?.globalSimilar === 'number'"
    max-width="375px"
    position="bottom start"
    :offset="0"
    close-on-content-click
  >
    <template #activator>
      <div
        class="d-flex align-center activator"
        v-bind="$attrs"
        @mouseover="$emit('tracking-event', {
          action: 'hoveredJob',
          args: {
            job: {
              jobId,
              specificityKey,
              specificityData,
              specificityLabel,
              globalSimilar,
              localSimilar,
            },
          },
        });"
      >
        <EstimatedCandidatesIcon
          class="mr-2 candidate-icon"
          :specificity-label="specificityLabel"
        />
        <p class="text-h3">
          {{ specificityLabel }}
          <span class="text-body-3 text-textLight">
            Candidate pool
          </span>
        </p>
      </div>
    </template>
    <EstimatedCandidatesDropdownMenu
      :specificity-label="specificityLabel"
      :global-similar="globalSimilar"
      :local-similar="localSimilar"
      :hide-tooltip-icon="hideTooltipIcon"
    />
  </DpplEnhancedTooltip>
</template>
<script>
import EstimatedCandidatesDropdownMenu from '@/components/editor/EstimatedCandidatesDropdownMenu.vue';
import EstimatedCandidatesIcon from '@/components/editor/EstimatedCandidatesIcon.vue';
import DpplEnhancedTooltip from '@/components/datapeople/DpplEnhancedTooltip.vue';

export default {
  name: 'EstimatedCandidatesDropdown',
  components: {
    EstimatedCandidatesDropdownMenu,
    EstimatedCandidatesIcon,
    DpplEnhancedTooltip,
  },
  props: {
    jobId: { type: [String, Number], default: '' },
    specificityKey: { type: Number, default: 0 },
    specificityData: { type: Object, default: () => ({}) },
    hideTooltipIcon: { type: Boolean, default: false },
  },
  emits: ['tracking-event'],
  computed: {
    specificityLabel() {
      return {
        1: 'Small Local', 2: 'Small', 3: 'Medium', 4: 'Large',
      }[this.specificityKey] || '';
    },
    globalSimilar() {
      return this.usLocaleNumber(this.specificityData.globalSimilar);
    },
    localSimilar() {
      if (this.specificityData.localSimilar === null) {
        return null;
      }
      return this.usLocaleNumber(this.specificityData.localSimilar);
    },
  },
  methods: {
    usLocaleNumber(x) {
      const sx = (`${x}`).split('.'); let s = ''; let i; let
        j;
      i = sx[0].length;
      while (i > 3) {
        j = i - 3;
        s = `,${sx[0].slice(j, i)}${s}`;
        i = j;
      }
      s = sx[0].slice(0, i) + s;
      sx[0] = s;
      return sx.join('.');
    },
  },
};
</script>
<style scoped lang="less">
.activator {
  height: 100%;
}
:deep(.candidate-icon) {
  max-width: 25px;
  width: 25px;
}
</style>
